<script>
import draggable from 'vuedraggable'

import { setNavOrder } from '@/api/config'

import { themeConfigureImgUrl } from '@/utils/common'
import { toPathWhiteList } from '@/defaultFields/index.js'

import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',
  components: { draggable },
  data() {
    return {
      routeIndex: 0,
      currentCommunity: localStorage.getItem('currentCommunity'),
      navbarList: [],
      currentNavIndex: 0,
      draggableDisable: true,
      admini: localStorage.getItem('admini'),
      currentPath: this.$route.path,
      toPath: '',
      whiteList: toPathWhiteList
    }
  },
  computed: {
    ...mapGetters({
      navListGetter: 'config/getNavList',
      currentPageTitle: 'config/getCurrentPageTitle',
      currentPageTitleId: 'config/getCurrentPageTitleId',
      theme: 'config/getThemeObj',
      getToPath: 'config/getToPath'
    }),
    navListData() {
      return this.navListGetter
    },
    currentNavTitle() {
      return this.currentPageTitle
    },
    currentNavTitleId() {
      return this.currentPageTitleId
    },
    themeObj() {
      return this.theme
    }
  },
  watch: {
    $route(to, from) {
      this.toPath = to.path
      // console.log('to', this.toPath)
    },
    // monitor current nav, redirect to corresponding route
    currentNavTitleId(newVal, oldVal) {
      if (!this.whiteList.includes(this.currentPath)) {
        this.navbarList.forEach((item, idx) => {
          if (item.id === newVal) {
            const path = item.path ? item.path : '/development'
            // const path = item.path === '/fireFighting' ? item.path : '/newPage11' // for dev
            this.$router.push({ path, query: { num: this.routeIndex++ }})
            this.currentNavIndex = idx
            // this.$store.commit('config/SET_SCREEN_SIZE', 1)
          }
        })
      }
    },
    /* currentNavIndex assignment */
    navListData(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.navbarList = newVal
        newVal.forEach((item, idx) => {
          if (item.templateName === this.currentNavTitle && item.id === this.currentNavTitleId) {
          // const path = item.path ? item.path : '/development'
          // this.$router.push({ path })
            this.currentNavIndex = idx
          }
        })
      }
    },
    /* current nav scroll */
    currentNavIndex(newVal, oldVal) {
      this.$nextTick(() => {
        const parent = document.querySelector('.nav-drag-main-content span')
        const child = document.querySelector(`.nav-drag-main-content span .nav-item-${newVal - 1}`)
        const scrollVal = newVal > 2 ? child.offsetTop : 0
        parent.scrollTo({ top: scrollVal, behavior: 'smooth' })
      })
    }
  },
  mounted() {
    this.getNavData()
  },
  methods: {
    themeConfigureImgUrl,
    getNavData() {
      const businessId = localStorage.getItem('businessId')
      this.$store.dispatch('config/getNavListReq', { businessId }).then(res => {
        if (res !== 'err' && !this.getToPath) {
          res.forEach((item, idx) => {
            if (item.templateName === this.currentNavTitle && item.id === this.currentNavTitleId) {
              const path = item.path ? item.path : '/development'
              // console.log('getNavData')
              this.$router.push({ path })
              this.currentNavIndex = idx
            }
          })
        }
      })
    },
    setClass(idx) {
      return `nav-item-${idx}`
    },

    handleNavClick({ templateName: title, id }, i) {
      if (this.currentNavIndex !== i) {
        this.currentNavIndex = i
        // this.$store.commit('config/SET_CURRENT_TITLE', v.title)
        this.$emit('handleNavClickFn', { title, id })
      }
    },
    onMove(evt) { // 禁止拖动社区简介和村简介
      return evt.related.className.indexOf('forbid') === -1
    },
    datadragEnd(evt) {
      evt.preventDefault()
      // console.log('拖动前: ', evt)
      // console.log('拖动后', evt)
      // console.log('taskFileList: ', this.navbarList)
      const navIds = []
      this.navbarList.forEach(item => navIds.push(item.id))
      const params = { village: this.currentCommunity, id: navIds.join(',') }
      setNavOrder(params).then(res => {
        if (res.code == 0) this.$store.dispatch('config/getNavListReq', { businessId: 0 })
      })
    },
    handleDraggableDisabled() {
      if (this.navListData.length === 0) {
        this.$message.warning('暂无菜单数据')
        return
      }
      this.draggableDisable = !this.draggableDisable
    },
    handleToggleClick(type) {
      if (this.navListData.length === 0) {
        this.$message.warning('暂无菜单数据')
        return
      }
      // const parent = document.querySelector('.nav-drag-main-content span')
      this.navListData.forEach((item, idx) => {
        if (type === 'up') {
          if (this.currentNavIndex > 0 && this.currentNavIndex === idx) {
            const { templateName: title, id } = this.navListData[idx - 1]
            this.$emit('handleNavClickFn', { title, id }) // this.navListData[idx - 1].templateName
          }
        } else {
          if (this.currentNavIndex + 1 < this.navListData.length && this.currentNavIndex === idx) {
            const { templateName: title, id } = this.navListData[idx + 1]
            this.$emit('handleNavClickFn', { title, id }) // this.navListData[idx + 1].templateName
          }
        }
      })
    },
    closeNavbar() {
      this.draggableDisable = true
      this.$emit('closeNavbar')
    },

    /* top menu of nav */
    toPartyTop(path) {
      if (path) this.$router.push(path)
    },

    templateNameFilter(title) {
      let titleStr = ''
      switch (title) {
        case '社区简介': titleStr = `${this.admini}简介`
          break
        case '村简介': titleStr = `${this.admini}简介`
          break
        case '居务公开': titleStr = this.admini === '社区' ? '居务公开' : '村务公开'
          break
        default: titleStr = title
      }
      return titleStr
    }
  }
}
</script>

<template>
  <div
    class="navbar"
    :style="{
      background: `url(${themeConfigureImgUrl(themeObj.navBg)}) no-repeat center`,
      backgroundSize: '100% 100%'
    }"
  >
    <el-image
      v-if="themeObj.navTopPattern"
      :src="themeConfigureImgUrl(themeObj.navTopPattern)"
      fit="cover"
      :style="{
        width: `${$px2rem(`${themeObj.patternWidth}px`)}`,
        height: `${$px2rem(`${themeObj.patternHeight}px`)}`,
        top: `${$px2rem(`${22 - themeObj.patternHeight}px`)}`}"
      class="nav-top-pattern"
    />
    <div
      class="nav-tool"
      :style="{
        background: `url(${themeConfigureImgUrl(themeObj.navTop)}) no-repeat center`,
        backgroundSize: '100% 100%'
      }"
      @click="closeNavbar"
    >收起菜单</div>
    <img
      class="arrow-logo logo-up"
      :src="currentNavIndex == 0
        ? themeConfigureImgUrl(themeObj.arrowUp)
        : themeConfigureImgUrl(themeObj.arrowUpActive)"
      alt="arrow-up"
      @click="handleToggleClick('up')"
    >
    <!-- <img
      class="arrow-logo logo-up"
      :src="currentNavIndex == 0
        ? require('imgs/arrow-up.png')
        : require('imgs/arrow-up-active.png')"
      alt="arrow-up"
      @click="handleToggleClick('up')"
    > -->
    <div class="nav-partyTop">
      <p class="nav-partyTop-item" @click="toPartyTop( '/mobileIndex')">智慧党建</p><!-- /partyBuilding /mobileIndex  -->
      <p class="nav-partyTop-item" @click="toPartyTop('/peopleCongress20')">洪雅党员教育</p>
      <!-- <p class="nav-partyTop-item" @click="toPartyTop('/hometownAtlas')">图说洪雅变化</p>
      <p class="nav-partyTop-item" @click="toPartyTop('/resultBook')">成果汇编</p> -->
    </div>
    <div class="draggable-box">
      <img v-if="themeObj.navShadow" class="nav-shadow" :src="themeConfigureImgUrl(themeObj.navShadow)" alt="nav-shadow">
      <!-- <img class="nav-shadow" :src="require('imgs/nav-shadow.png')" alt="nav-shadow"> -->
      <draggable
        v-model="navbarList"
        class="nav-drag-main-content"
        animation="800"
        :disabled="draggableDisable"
        filter=".forbid"
        :move="onMove"
        @update="datadragEnd"
      >
        <transition-group>
          <div
            v-for="(v, i) in navbarList"
            :key="`nav-${v.templateName}-${i}`"
            :class="[setClass(i), {'forbid': ['社区简介', '村简介'].includes(v.templateName)}]"
          >
            <div
              class="main-item"
              :class="{'main-item-active': i == currentNavIndex,
                       'main-item-animation': !draggableDisable && !['社区简介', '村简介'].includes(v.templateName)}"
              :style="{
                background: `url(${i == currentNavIndex
                  ? themeConfigureImgUrl(themeObj.navBtnActive)
                  : themeConfigureImgUrl(themeObj.navBtn)}) no-repeat center`,
                backgroundSize: '100% 100%'
              }"
              @click="handleNavClick(v, i)"
            >
              <p
                class="item-title"
                :class="{'text-break': v.templateName.length > 7}"
                :style="{color: i == currentNavIndex ? themeObj.activeColor : themeObj.color}"
              >{{ templateNameFilter(v.templateName) }}</p>
            </div>
          </div>
        </transition-group>
      </draggable>
    </div>
    <img
      class="arrow-logo logo-down"
      :src="currentNavIndex + 1 == navListData.length
        ? themeConfigureImgUrl(themeObj.arrowDown)
        : themeConfigureImgUrl(themeObj.arrowDownActive)"
      alt="arrow-down"
      @click="handleToggleClick('down')"
    >
    <!-- <img
      class="arrow-logo logo-down"
      :src="currentNavIndex + 1 == navListData.length
        ? require('imgs/arrow-down.png')
        : require('imgs/arrow-down-active.png')"
      alt="arrow-down"
      @click="handleToggleClick('down')"
    > -->
    <div
      class="nav-tool edit-tool"
      :style="{
        background: `url(${themeConfigureImgUrl(themeObj.navBottom)}) no-repeat center`,
        backgroundSize: '100% 100%'
      }"
      @click="handleDraggableDisabled"
    >{{ draggableDisable ? '编辑顺序' : '关闭编辑' }}</div>
  </div>
</template>

<style lang="scss" scoped>
.navbar {
  width: 199px;
  height: 604px;
  // background: url('~imgs/navbar-webp.png') no-repeat center;
  background-size: 100% 100% !important;
  padding: 22px 0 29px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .nav-top-pattern {
    position: absolute;
  }
  .nav-tool {
    width: 100px;
    height: 28px;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    display: grid;
    place-items: center;
    // background: url('~imgs/nav-top.png') no-repeat center;
    background-size: 100% 100% !important;
    cursor: pointer;
  }
  .edit-tool {
    // background: url('~imgs/nav-bottom.png') no-repeat center;
    background-size: 100% 100% !important;
  }
  .arrow-logo {
    width: 24px;
    height: 19px;
    cursor: pointer;
  }

  .nav-partyTop {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    .nav-partyTop-item {
      width: 125px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 15px;
      font-weight: bold;
      color: #fff;
      background-color: #FF9049;
      border: 1px solid #fff;
      box-shadow: 0px 0px 6px 0px rgba(13,112,80,0.35);
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .draggable-box {
    position: relative;
    .nav-shadow {
      position: absolute;
      left: 0;
      bottom: -20px;
      width: 132px;
      height: 46px;
    }
  }
  .nav-drag-main-content {
    width: 125px;
    // height: 320px;
    height: 280px;
    span {
      width: 125px;
      // height: 320px;
      height: 280px;
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      overflow-y: scroll;
      box-sizing: border-box;
      padding-bottom: 200px;
      &::-webkit-scrollbar { // chrome/safari
        display: none;
      }
      scrollbar-width: none; // firefox
      -ms-overflow-style: none; // IE10+
    }
    .main-item {
      width: 125px;
      height: 40px;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      // background: url('~imgs/nav-btn.png') no-repeat center;
      background-size: 100% 100% !important;
      cursor: pointer;
      .item-title {
        font-size: 15px;
        font-weight: bold;
        // color: #0C485D;
      }
    }
    .main-item-active {
      // background: url('~imgs/nav-btn-active.png') no-repeat center;
      background-size: 100% 100% !important;
      // .item-title {
      //   color: #fff;
      // }
    }
    .main-item-animation {
      animation: rotateK .4s linear infinite;
    }
  }
}

@keyframes rotateK {
  0% {transform: rotate(0);}
  25% {transform: rotate(-2deg);}
  50% {transform: rotate(0);}
  75% {transform: rotate(2deg);}
  100% {transform: rotate(0);}
}
</style>
